import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-arcade-logo",
  "aria-hidden": "true"
}, "🕹️", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "nge-arcade-title" }, "Pyr Arcade", -1 /* HOISTED */)
const _hoisted_3 = { class: "nge-arcade-games" }
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = { class: "nge-arcade-body" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "nge-arcade",
      role: "dialog",
      "aria-label": "Pyr Arcade",
      style: _normalizeStyle({ transform: `translate(calc(-50% + ${$setup.pos.x}px), calc(-50% + ${$setup.pos.y}px))` })
    }, [
      _createElementVNode("div", {
        class: "nge-arcade-head",
        onPointerdown: $setup.onDragStart,
        onPointermove: $setup.onDragMove,
        onPointerup: $setup.onDragEnd,
        onPointercancel: $setup.onDragEnd
      }, [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.GAMES, (g) => {
            return _createElementVNode("button", {
              key: g.id,
              class: _normalizeClass(["nge-arcade-game", { on: $setup.gameId === g.id }]),
              title: g.blurb,
              onClick: $event => ($setup.gameId = g.id)
            }, _toDisplayString(g.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_4)
          }), 64 /* STABLE_FRAGMENT */))
        ]),
        _createElementVNode("button", {
          class: "nge-arcade-close",
          title: "Close (Esc)",
          "aria-label": "Close the arcade",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
        }, "×")
      ], 32 /* HYDRATE_EVENTS */),
      _createElementVNode("div", _hoisted_5, [
        ($setup.gameId === 'tetris')
          ? (_openBlock(), _createBlock($setup["NeuronTetris"], { key: 0 }))
          : _createCommentVNode("v-if", true)
      ])
    ], 4 /* STYLE */)
  ]))
}